import React from 'react';
import './SelectedDateTime.css';
import ConsoleLog from './../../../../hoc/ConsoleLog/ConsoleLog';

const SelectedDateTime = (props) => {
                    
  return(
      <div className="dates-times-selected">
        <h4>{props.fromCandidate && props.fromCandidate?"Choose a time that suits you best":"Dates and times selected for interview"}</h4>
        <ul>
          {props.candidateSlots.length > 0? props.candidateSlots.map((slot) => {
            const slotStatusClass=slot.slotStatus==="accepted"?"accepted-grey-card":null;
            const glowClass = props.selectedDateTime && ((props.selectedDateTime.time === slot.time) && (props.selectedDateTime.date === slot.date))?"selectedGlow":" ";
            return(
              <li className={slotStatusClass+" "+glowClass} onClick={() => {
                if(props.datesSelectable){
                  props.handleDateTimeSelect(slot)
                }else{
                  ConsoleLog('Outside click');
                }
              }}>
                <span className="time-selected">{slot.time}</span>
                <span className="date-selected">{slot.date}</span>
              </li>
            )
          }):""}
        </ul>
      </div>  
  );
}

export default SelectedDateTime;


// WEBPACK FOOTER //
// ./src/components/Client/ClientInterviewSchedular/SelectedDateTime/SelectedDateTime.js